module.exports = __webpack_public_path__ + "static/media/download_black.3a8a16bf.png";